import { createRouter, createWebHistory } from 'vue-router'
import { store } from '../store/storeModules.js';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/main/Home.vue')
  },
  {
    path: '/announcement',
    name: 'Announcement',
    component: () => import('../views/main/Announcement.vue')
  },
  {
    path: '/announcement/page/:pageId',
    name: 'AnnouncementPage',
    component: () => import('../views/main/Announcement.vue')
  },
  {
    path: '/announcement/:annoucementID',
    name: 'AnnouncementPost',
    component: () => import('../views/main/AnnouncementPost.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/main/About.vue'),
    // meta: {
    //   title: '關於我們 - T-KI',
    // }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/main/Contact.vue')
  },
  {
    path: '/cooperate',
    name: 'Cooperate',
    component: () => import('../views/main/Cooperate.vue')
  },
  {
    path: '/delete-account',
    name: 'DeleteAccount',

    component: () => import('../views/main/DeleteAccount.vue')
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('../views/main/FAQ.vue')
  },
  {
    path: '/service-terms',
    name: 'ServiceTerms',
    component: () => import('../views/main/ServiceTerms.vue')
  },
  {
    path: '/privacy-terms',
    name: 'PrivacyTerms',
    component: () => import('../views/main/PrivacyTerms.vue')
  },
  {
    path: '/copyright',
    name: 'Copyright',
    component: () => import('../views/main/Copyright.vue')
  },
  {
    path: '/download-app',
    name: 'DownloadApp',
    component: () => import('../views/main/DownloadApp.vue')
  },
  {
    // 依裝置導向 App Store / Google Play，判斷不出來則顯示雙平台連結
    path: '/app',
    name: 'AppRedirect',
    component: () => import('../views/main/AppRedirect.vue')
  },
  {
    path: '/search/:searchText',
    name: 'Search',
    component: () => import('../views/main/Search.vue')
  },
  {
    path: '/member',
    name: 'Member',
    component: () => import('../views/main/Member/Layout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'index/:memberID',
        name: 'Index',
        component: () => import('../views/main/Member/Index.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'info/:memberID',
        name: 'Info',
        component: () => import('../views/main/Member/Info.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'order-history/:memberID',
        name: 'OrderHistory',
        component: () => import('../views/main/Member/OrderHistory.vue')
      },
      {
        path: 'reward/:memberID',
        name: 'Reward',
        component: () => import('../views/main/Member/Reward.vue')
      },
      {
        path: 'my-collection/:memberID',
        name: 'MyCollection',
        component: () => import('../views/main/Member/MyCollection.vue')
      },
      {
        path: 'my-ticket/:memberID',
        name: 'MyTicket',
        component: () => import('../views/main/Member/MyTicket.vue')
      },
      {
        path: 'my-selection/:memberID',
        name: 'MySelection',
        component: () => import('../views/main/Member/MySelection.vue')
      },
      {
        path: 'ticket-list/:memberID',
        name: 'TicketList',
        component: () => import('../views/main/Member/TicketList.vue')
      },
      {
        path: 'refund/:memberID',
        name: 'Refund',
        component: () => import('../views/main/Member/Refund.vue'),
      },
    ]
  },
  {
    path: '/activity',
    name: 'Activity',
    component: () => import('../views/main/Activity/Layout.vue'),
    children: [
      {
        path: ':activityClassId',
        component: () => import('../views/main/Activity/Inner.vue')
      },
      {
        path: 'reserve-ticket',
        component: () => import('../views/main/Activity/ReserveTicket.vue')
      },
      {
        path: 'detail/:activityId',
        redirect: { name: 'BuyTicketSession' },
        component: () => import('../views/main/Activity/ActivityDetail/ActivityDetail.vue'),
        children: [
          {
            path: 'news',
            name: 'News',
            component: () => import('../views/main/Activity/ActivityDetail/News.vue'),
          },
          {
            path: 'lottery',
            name: 'Lottery',
            component: () => import('../views/main/Activity/ActivityDetail/Lottery.vue')
          },
          {
            path: 'buy-ticket',
            name: 'BuyTicket',
            component: () => import('../views/main/Activity/ActivityDetail/BuyTicket.vue'),
            children: [
              {
                path: 'session',
                name: 'BuyTicketSession',
                component: () => import('../views/main/Activity/ActivityDetail/BuyTicketSession.vue')
              },
              {
                path: 'type',
                name: 'BuyTicketType',
                component: () => import('../views/main/Activity/ActivityDetail/BuyTicketType.vue')
              },
              // 座位圖拉出去另外做
              // {
              //   path: 'seat',
              //   name: 'BuyTicketSeat',
              //   component: () => import('../views/main/Activity/ActivityDetail/BuyTicketSeat.vue')
              // },
              {
                path: 'cart',
                name: 'BuyTicketCart',
                component: () => import('../views/main/Activity/ActivityDetail/BuyTicketCart.vue')
              },
              {
                path: 'cart-list',
                name: 'BuyTicketCartList',
                component: () => import('../views/main/Activity/ActivityDetail/BuyTicketCartList.vue')
              },
              {
                path: 'checkout',
                name: 'BuyTicketCheckout',
                component: () => import('../views/main/Activity/ActivityDetail/BuyTicketCheckout.vue')
              },
              {
                path: 'payment',
                name: 'BuyTicketPayment',
                component: () => import('../views/main/Activity/ActivityDetail/BuyTicketPayment.vue')
              },
            ]
          },
          {
            path: 'location',
            name: 'Location',
            component: () => import('../views/main/Activity/ActivityDetail/Location.vue')
          },
          {
            path: 'notes',
            name: 'Notes',
            component: () => import('../views/main/Activity/ActivityDetail/Notes.vue')
          },
        ]
      },
      {
        path: 'news-detail/:newsId',
        name: 'NewsDetail',
        component: () => import('../views/main/Activity/ActivityDetail/NewsDetail.vue')
      },
    ]
  },
  {
    path: '/ticket-seats/:activityId',
    name: 'TicketSeats',
    component: () => import('../views/main/Activity/TicketSeats.vue')
  },
  {
    path: '/ticket-seats-result',
    name: 'TicketSeatsResult',
    component: () => import('../views/main/Activity/TicketSeatsResult.vue')
  },
  {
    path: '/newebpay-callback',
    name: 'BuyTicketCallback',
    component: () => import('../views/main/Activity/ActivityDetail/BuyTicketCallback.vue')
  },
  {
    path: '/event-redirect',
    name: 'EventRedirect',
    component: () => import('../views/main/Activity/EventRedirect.vue')
  },
  {
    path: '/line-login',
    name: 'LineLogin',
    component: () => import('../views/main/LineLogin.vue')
  },
  {
    path: '/apple-login',
    name: 'AppleLogin',
    component: () => import('../views/main/AppleLogin.vue')
  },
  {
    path: '/apple-redirect',
    name: 'AppleRedirect',
    component: () => import('../views/main/AppleRedirect.vue')
  },
  {
    path: '/sv-login',
    name: 'SVLogin',
    component: () => import('../views/main/SVLogin.vue')
  },
  { path: '/r18reminder',
    name: 'R18reminder',
    component: () => import('../views/main/R18reminder.vue')
  },  
  { path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/main/NotFound.vue')
  },  
]

const router = createRouter({
  mode: 'history',
  history: createWebHistory(process.env.VUE_APP_BUILD_PATH),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let loginStatus = store.getters['user/getLoginStatus'];
    if (!loginStatus) {
      next('/');
      return;
    }
  }

  // 已登入但 Email 未完成：強制留在會員資訊頁，完成前不可離開
  const loginStatus = store.getters['user/getLoginStatus'];
  const loginData = store.getters['user/getLoginData'];
  if (loginStatus && loginData?.access_token && to.name !== 'Info') {
    let gate = null;
    try {
      const res = await store.dispatch('user/checkVerifiedMail');
      gate = res ? res.email_gate : null;
    } catch (_) {
      gate = null;
    }
    if (gate === 'required' || gate === 'verify') {
      const memberId = store.state.user.memberData?.data?.id;
      if (memberId) {
        next({
          name: 'Info',
          params: { memberID: memberId },
          query: { forceEmailStay: '1' },
        });
        return;
      }
    }
  }

  next();
});

export default router
